







































































import Vue from "vue";
import { Header } from "@/components/MyTabs.vue";
import Overview from "./AppInfo/Overview.vue";
import Pod from "./AppInfo/Pod.vue";
// import Service from "./AppInfo/Service.vue";
import Container from "./AppInfo/Container.vue";
import Grayscale from "./AppInfo/Grayscale.vue";

import { uuid } from "../../utils/uuid";
import { eventBus } from "../../utils/event";
import { axios } from "../../plugins";
const Tabs: Header[] = [
  { label: "概览", name: "tab1", uuid: uuid() },
  { label: "Pod组", name: "tab2", uuid: uuid() },
  // { label: "服务", name: "tab3", uuid: uuid() },
  { label: "容器", name: "tab4", uuid: uuid() },
  { label: "灰度发布", name: "tab5", uuid: uuid() }
];

export default Vue.extend({
  name: "AppInfo",
  components: { Overview, Pod, Container, Grayscale },
  props: { projectId: { type: String } },
  inheritAttrs: false,
  data() {
    return {
      Tabs,
      dialog: false,
      tabActive: "tab1",
      data: null as any,
      appData: null as any,
      type: ""
    };
  },
  computed: {
    dynamicTab(): Header[] {
      if (this.type === "有状态组件") {
        return this.Tabs.slice(0, 4);
      }
      return this.Tabs;
    },
    tagColor() {
      if (!this.appData) return "";

      if (!this.appData.status.readyReplicas) {
        return "red";
      } else if (
        this.appData.status.readyReplicas === this.appData.spec.replicas
      ) {
        return "green";
      } else {
        return "orange";
      }
    },
    tagValue() {
      if (!this.appData) return "";
      if (!this.appData.status.readyReplicas) {
        return "异常";
      } else if (
        this.appData.status.readyReplicas === this.appData.spec.replicas
      ) {
        return "运行中";
      } else {
        return "更新中";
      }
    }
  },
  deactivated() {
    this.dialog = false;
    this.tabActive = "tab1";
  },
  watch: {
    tabActive(val) {
      const tab = Tabs.find(item => item.name === val);
      eventBus.$emit("setBeard", {
        name: (tab as Header).label,
        is4Path: true
      });
    }
  },
  methods: {
    show(data: any, type: string) {
      this.data = data;
      this.type = type;
      if (this.data.__restart) {
        this.tabActive = "tab4";
      }
      this.getData().then(() => {
        this.dialog = true;
      });
    },
    getData() {
      let url = "";
      if (this.type === "无状态组件") {
        url = "/deployment/";
      } else if (this.type === "有状态组件") {
        url = "/statefulset/";
      }
      return axios
        .get(`${url}${this.projectId}/${this.data.metadata.name}`)
        .then(res => {
          this.appData = res.data.data;
        });
    },
    refush() {
      this.getData();
      (this.$refs[this.tabActive] as any).refush();
    },
    close() {
      this.dialog = false;
      // 此项设置会触发 tabActive watch
      // 导致 面包屑 触发 setBeard
      // 目前是在面包屑上加 $nextTick
      this.tabActive = "tab1";
    }
  }
});
